export const shellyConfig = {
  common: {
    saving: "Guardando...",
    online: "En línea",
    offline: "Sin conexión",
  },

  step1: {
    title: "Configuración de Shelly",
    subtitle:
      "Conecta tu cuenta de Shelly Cloud para controlar tus relés (cerraduras eléctricas, portones, etc.).",
    connected: "Cuenta conectada",
    notConnected: "Sin conectar",
    credentialsInfo:
      "Encuentra tus credenciales en la app de Shelly: <b>Ajustes de usuario → Clave de autorización cloud</b>. Ahí verás el <b>Server URI</b> y podrás generar tu <b>Auth Key</b>.",
    serverUriPlaceholder: "Ej: shelly-103-eu.shelly.cloud",
    serverUriHelp: "Servidor cloud asignado a tu cuenta Shelly.",
    authKeyPlaceholderSaved: "•••••••• (ya guardada, opcional cambiar)",
    authKeyPlaceholderNew: "Pega tu clave de autorización cloud",
    authKeyHelpSaved: "Puedes dejarlo vacío si ya tienes una clave guardada.",
    authKeyHelpNew:
      "Esta clave permite controlar tus dispositivos: guárdala con cuidado.",
    testing: "Probando...",
    testConnection: "Probar Conexión",
    saveCredentials: "Guardar credenciales",
  },

  step2: {
    title: "Selector de dispositivos para esta propiedad",
    subtitle:
      "Selecciona solo los relés Shelly que aplican a <b>esta propiedad</b>. Luego, en el PMS verás únicamente los seleccionados.",
    selectedCount: "{count} seleccionado(s)",
    hintCredentials:
      "Ingresa tu Server URI y Auth Key y pulsa <b>Probar Conexión</b> para cargar tus dispositivos.",
    noDevices: "No se encontraron dispositivos en tu cuenta Shelly.",
    selectPlaceholder: "Selecciona dispositivos…",
    devicesSelected: "{count} dispositivo(s) seleccionado(s)",
    noneSelected: "Ningún dispositivo seleccionado",
    channels: "{count} canales",
    saveDevices: "Guardar dispositivos de esta propiedad",
  },

  step3: {
    title: "Control y asignación (PMS)",
    subtitle:
      "Asigna cada relé a <b>Puerta principal</b>, <b>Unidad</b> o <b>Portón</b> y configura el pulso de apertura.",
    assignedCount: "{count} asignado(s)",
    noSavedDevices:
      "Aún no tienes dispositivos guardados para esta propiedad. Usa el <b>Selector</b> arriba y luego guarda.",
    pulseInfo:
      "<b>Abrir</b> envía un pulso al relé (se enciende y se apaga solo tras los segundos configurados): ideal para cerraduras eléctricas y portones. Shelly no genera códigos PIN.",
    open: "Abrir",
    openTooltip: "Abrir (pulso)",
    turnOnTooltip: "Encender relé",
    turnOffTooltip: "Apagar relé",
    refreshTooltip: "Actualizar estado",
    assignment: "Asignación",
    assignNone: "Sin asignar",
    assignCommon: "Puerta principal (común)",
    assignUnit: "Puerta de apartamento",
    assignGate: "Portón / Garaje",
    hintNone: "No se controlará desde PMS.",
    hintAssigned: "Quedará asociado a esta propiedad para apertura remota.",
    unitLabel: "Unidad / Alojamiento",
    selectUnit: "Selecciona una unidad",
    unitFallback: "Unidad {id}",
    selectUnitHint: "Selecciona qué unidad abre este relé.",
    channelLabel: "Canal del relé",
    channelOption: "Canal {n}",
    channelHint: "Canal conectado a la cerradura (equipos multi-relé).",
    pulseLabel: "Pulso de apertura (segundos)",
    pulseHint: "Tiempo que el relé queda encendido al abrir.",
    nameLabel: "Nombre (opcional)",
    namePlaceholder: "Ej: Puerta principal / Apt 101",
    nameHint: "Nombre visible en el PMS para este dispositivo.",
    saveAssignment: "Guardar asignación",
    tip:
      "Tip: Asigna cada relé y pulsa <b>Guardar asignación</b>. Los botones de control se habilitan cuando el dispositivo está asignado.",
  },

  toast: {
    loadDevicesFailed: "No se pudieron cargar los dispositivos",
    loadDevicesError: "Error cargando dispositivos",
    missingCredentials: "Debes ingresar el Server URI y tu Auth Key de Shelly.",
    connectionSuccess:
      "Conexión exitosa. {count} dispositivo(s) encontrado(s).",
    testError: "Error al probar la conexión",
    invalidAuthKey: "Debes ingresar una Auth Key válida (mínimo 10 caracteres).",
    missingServerUri: "Debes ingresar el Server URI de tu cuenta Shelly.",
    credentialsSaved: "Credenciales guardadas correctamente",
    credentialsError: "Error al guardar credenciales",
    credentialsSaveError: "Error al guardar credenciales: {error}",
    selectAtLeastOne:
      "Debes seleccionar al menos un dispositivo para esta propiedad.",
    devicesSaved: "Dispositivos guardados para esta propiedad",
    devicesSaveFailed: "No se pudieron guardar los dispositivos",
    saveError: "Error al guardar: {error}",
    selectUnitForApartment:
      "Selecciona la unidad para los relés asignados como 'Puerta de apartamento'.",
    assignmentFailed: "No se pudo guardar la asignación",
    assignmentSaved: "Asignación guardada correctamente",
    assignmentSaveError: "Error al guardar asignación: {error}",
    opOpen: "Apertura enviada (pulso de relé)",
    opOn: "Relé encendido",
    opOff: "Relé apagado",
    opDone: "Acción ejecutada",
    opFailed: "No se pudo ejecutar la acción",
    opError: "Error al ejecutar la acción",
  },
};
